import { useClientsPage } from './useClientsPage';
import { ClientsHeader } from './sections/ClientsHeader';
import { ClientsFilterBar } from './sections/ClientsFilterBar';
import { ClientsGrid } from './sections/ClientsGrid';
import { ClientsPagination } from './sections/ClientsPagination';
import { DeleteClientModal } from './sections/DeleteClientModal';

export default function ClientsPage() {
  const {
    navigate,
    page,
    setPage,
    search,
    setSearch,
    statusFilter,
    setStatusFilter,
    deleteId,
    setDeleteId,
    isPending,
    clients,
    stats,
    filtered,
    totalPages,
    total,
    hasFilters,
    clearFilters,
    isDeleting,
    confirmDelete,
  } = useClientsPage();

  return (
    <div className="mx-auto flex w-full max-w-6xl flex-col gap-5">
      <ClientsHeader
        isPending={isPending}
        total={total}
        onCreate={() => navigate('/clients/add')}
        showStats={!isPending && clients.length > 0}
        stats={stats}
      />

      <ClientsFilterBar
        search={search}
        onSearchChange={setSearch}
        statusFilter={statusFilter}
        onStatusChange={setStatusFilter}
        hasFilters={hasFilters}
        onClearFilters={clearFilters}
      />

      <ClientsGrid
        isPending={isPending}
        hasAnyClients={clients.length > 0}
        filtered={filtered}
        onCreate={() => navigate('/clients/add')}
        onView={(id) => navigate(`/clients/${id}`)}
        onEdit={(id) => navigate(`/clients/${id}/edit`)}
        onDelete={setDeleteId}
      />

      {!isPending && clients.length > 0 && filtered.length > 0 && totalPages > 1 && !hasFilters ? (
        <ClientsPagination page={page} totalPages={totalPages} onPageChange={setPage} />
      ) : null}

      <DeleteClientModal
        open={Boolean(deleteId)}
        isDeleting={isDeleting}
        onCancel={() => setDeleteId(null)}
        onConfirm={confirmDelete}
      />
    </div>
  );
}
